import { render } from "./DepartmentInnerPage.vue?vue&type=template&id=d6cc261c&scoped=true"
import script from "./DepartmentInnerPage.vue?vue&type=script&lang=js"
export * from "./DepartmentInnerPage.vue?vue&type=script&lang=js"

import "./DepartmentInnerPage.vue?vue&type=style&index=0&id=d6cc261c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6cc261c"]])

export default __exports__